<template>
  <div class="issues-category-item-container col-lg-6 mt-4">
    <Section>
      <div class="section-header" slot="header">
        <h1 class="title">{{ categoryName }}</h1>
        <div class="section-header-right">
          <h5
            class="issues-category-item__category-percentage"
            :style="{
              backgroundColor: mainColor
            }" >
            {{ categoryPercentage }}%
          </h5>
        </div>
      </div>
      <div class="section-body">
        <div v-if="!categoryEmpty">
          <DonutChart
            :series="series"
            :labels="labels"
            :colors="colors"
            :showLegend="false" />
          <LegendContainer :percentage="series" :labels="labels" :colors="colors" />
        </div>
        <div v-if="categoryEmpty">
          <h4 class="issues-category-item__no-issues text-center align-middle">
            <h1 class="mb-4"><i class="fa fa-thumbs-up ml-2" /></h1>
            No issues in this category.
          </h4>
        </div>
      </div>
    </Section>
  </div>
</template>

<script>
import _ from 'lodash';
import getIssuesColor from '@/utils/colorGeneratorUtils';
// import getIssuesColor from '../utils/colorGeneratorUtils';
import DonutChart from '@/charts/DonutChart.vue';
import Section from '@/components/Section.vue';
import LegendContainer from '@/components/LegendContainer.vue';

export default {
  mixins: [getIssuesColor],
  props: ['categoryIssuesData'],
  components: {
    LegendContainer,
    DonutChart,
    Section,
  },
  data() {
    return {
      othersPercentage: 0,
      series: [],
      labels: [],
    };
  },
  computed: {
    categoryEmpty() {
      return this.categoryIssuesData.errorCount === 0;
    },
    categoryName() {
      return this.categoryIssuesData.name;
    },
    categoryPercentage() {
      return this.categoryIssuesData.errorPercentage.toFixed(2);
    },
    issueCodes() {
      return this.categoryIssuesData.errorCodes;
    },
    categoryColor() {
      return this.getIssuesColor(this.categoryIssuesData.key);
    },
    mainColor() {
      return this.categoryColor.mainColor;
    },
    colors() {
      if (this.series.length === 1) return [this.mainColor];
      return _.reverse(this.categoryColor.colors);
    },
  },
  created() {
    this.computeSeries();
    this.computeLabels();
  },
  methods: {
    computeSeries() {
      const series = _.map(this.issueCodes, (c, index) => {
        if (index >= 6) this.othersPercentage += c.percentageErrorInCategory;
        return c.percentageErrorInCategory;
      });
      if (series.length >= 7) {
        this.series = series.slice(0, 5);
        this.series.push(this.othersPercentage);
      } else this.series = series;
    },
    computeLabels() {
      const labels = _.map(this.issueCodes, c => c.errorCode);
      if (labels.length >= 7) {
        this.labels = labels.slice(0, 5);
        this.labels.push('Others');
      } else this.labels = labels;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.issues-category-item-container {
  .section {
    min-height: 540px;

    .section-header {
      position: relative;
    }

    .issues-category-item__no-issues {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 80%;
      transform: translate(-50%, -50%);
      margin: auto;
      color: $gray-500;
    }

    .issues-category-item__category-percentage {
      position: absolute;
      text-align: left;
      color: white;
      top: $spacer * .75;
      right: $spacer;
      background-color: red;
      padding: $spacer * .5;
      border-radius: 3px;
    }
  }
}
</style>
